import { render, staticRenderFns } from "./goldDetailTable.vue?vue&type=template&id=7c99e396"
import script from "./goldDetailTable.vue?vue&type=script&lang=js"
export * from "./goldDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports